import { Controller } from 'stimulus';

/**
 * details-state: Syncs the open/closed state of a <details> element to a hidden field.
 *
 * Usage:
 *   <details data-controller="details-state" data-action="toggle->details-state#sync">
 *     <input type="hidden" data-details-state-target="field" name="details_open" value="0">
 *     <summary>...</summary>
 *     ...
 *   </details>
 */
export default class extends Controller {
  static targets = ['field'];

  sync() {
    if (this.hasFieldTarget) {
      this.fieldTarget.value = this.element.open ? '1' : '0';
    }
  }
}
